import { Authenticated, Refine } from "@refinedev/core";
import routerProvider, { CatchAllNavigate, NavigateToResource } from "@refinedev/react-router";
import { BrowserRouter, Outlet, Route, Routes } from "react-router";

import { Layout } from "./components/Layout";
import { ToastProvider } from "./components/ui";
import { AuditLogPage } from "./pages/Audit";
import { BannersPage, CategoriesPage, CouponsPage, PackageTypesPage, SubscriptionPlansPage, PaymentMethodsPage, VendorTypesPage } from "./pages/Catalog";
import { DashboardPage } from "./pages/Dashboard";
import { DispatchPage } from "./pages/Dispatch";
import { EarningsPage, PayoutsPage, RemittancesPage } from "./pages/Finance";
import { BroadcastPage } from "./pages/Broadcast";
import { GeoPage } from "./pages/Geo";
import { ImportsPage } from "./pages/Imports";
import { TranslationsPage } from "./pages/Translations";
import { LoginPage } from "./pages/Login";
import { OrderDetailPage, OrdersPage } from "./pages/Orders";
import { SettingsPage } from "./pages/Settings";
import { UsersPage } from "./pages/Users";
import { VendorDetailPage, VendorsPage } from "./pages/Vendors";
import { authProvider } from "./providers/authProvider";
import { dataProvider } from "./providers/dataProvider";

export function App() {
  return (
    <BrowserRouter>
      <Refine
        routerProvider={routerProvider}
        authProvider={authProvider}
        dataProvider={dataProvider}
        resources={[
          { name: "dashboard", list: "/" },
          { name: "orders", list: "/orders", show: "/orders/:id" },
          { name: "dispatch", list: "/dispatch" },
          { name: "vendors", list: "/vendors", show: "/vendors/:id" },
          { name: "users", list: "/users" },
          { name: "vendor-types", list: "/vendor-types" },
          { name: "categories", list: "/categories" },
          { name: "banners", list: "/banners" },
          { name: "coupons", list: "/coupons" },
          { name: "package-types", list: "/package-types" },
          { name: "remittances", list: "/remittances" },
          { name: "earnings", list: "/earnings" },
          { name: "payouts", list: "/payouts" },
          { name: "payment-methods", list: "/payment-methods" },
          { name: "settings", list: "/settings" },
          { name: "audit-log", list: "/audit-log" },
          { name: "imports", list: "/imports" },
        ]}
        options={{ syncWithLocation: true, warnWhenUnsavedChanges: true, disableTelemetry: true }}
      >
        <ToastProvider>
          <Routes>
            <Route
              element={
                <Authenticated key="authenticated" fallback={<CatchAllNavigate to="/login" />}>
                  <Layout>
                    <Outlet />
                  </Layout>
                </Authenticated>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/orders/:id" element={<OrderDetailPage />} />
              <Route path="/dispatch" element={<DispatchPage />} />
              <Route path="/vendors" element={<VendorsPage />} />
              <Route path="/vendors/:id" element={<VendorDetailPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/vendor-types" element={<VendorTypesPage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/banners" element={<BannersPage />} />
              <Route path="/coupons" element={<CouponsPage />} />
              <Route path="/package-types" element={<PackageTypesPage />} />
              <Route path="/remittances" element={<RemittancesPage />} />
              <Route path="/earnings" element={<EarningsPage />} />
              <Route path="/payouts" element={<PayoutsPage />} />
              <Route path="/payment-methods" element={<PaymentMethodsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/audit-log" element={<AuditLogPage />} />
              <Route path="/imports" element={<ImportsPage />} />
              <Route path="/broadcast" element={<BroadcastPage />} />
              <Route path="/geo" element={<GeoPage />} />
              <Route path="/subscription-plans" element={<SubscriptionPlansPage />} />
              <Route path="/translations" element={<TranslationsPage />} />
            </Route>
            <Route
              element={
                <Authenticated key="anonymous" fallback={<Outlet />}>
                  <NavigateToResource resource="dashboard" />
                </Authenticated>
              }
            >
              <Route path="/login" element={<LoginPage />} />
            </Route>
          </Routes>
        </ToastProvider>
      </Refine>
    </BrowserRouter>
  );
}
